import {CANCEL, CONSULT_TYPE_MAP, FINSH, GOING, NEEDPAY, NOPAY_CANCEL} from "@/lib/config";

export const consultMixin = {
  computed: {
    consultType() {
      const {consult} = this;
      return consult.consultType || "";
    },
    isPersonal() {
      return this.consultType === CONSULT_TYPE_MAP.PERSONAL_TIME_PIC;
    },
    isRenewal() {
      return this.consultType === CONSULT_TYPE_MAP.RENEWAL_OF_CONSULTATION;
    },
    isTeam() {
      return this.consultType === CONSULT_TYPE_MAP.TEAMPIC;
    },
    isNeedPay() {
      return this.status === NEEDPAY;
    },
    isCancel() {
      return this.status === CANCEL;
    },
    isNopayCancel() {
      return this.status === NOPAY_CANCEL;
    },
    isGoing() {
      return this.status === GOING;
    },
    isFinish() {
      return this.status === FINSH;
    }
  },
}



// WEBPACK FOOTER //
// ./src/lib/mixins/consult.js